import { useState } from "react";
import config from "../../../config/config";
import AddRecognizedExchangesForm from "./addRecognizedExchnagesForm";
import { refreshRecognizedExchangeTableData } from "../../../observers/dataObserver";

// Styles
const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(0, 0, 0, 0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 10,
};

const modalStyle = {
  background: "white",
  borderRadius: "8px",
  width: "320px",
  padding: "20px",
  position: "relative",
  textAlign: "left",
};

const closeButtonStyle = {
  position: "absolute",
  top: "10px",
  right: "10px",
  background: "transparent",
  border: "none",
  fontSize: "18px",
  cursor: "pointer",
  color: "#333",
};

const AddRecognizedExchangesFormModal = ({ show, onClose }) => {
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false); // ✅ loader state

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // ✅ start loader
    const token = localStorage.getItem("token");

    const payload = {
      table: "RecognizedExchanges",
      row: { exchangeCountry: formData.country, exchangeName: formData.exchangeName, Status: formData.status === "true" },
    };

    try {
      const response = await fetch(`${config["backend-url"]}/Update_Required_Table`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        const result = await response.json();
        console.log("✅ User added successfully:", result);
        setFormData({});
        refreshRecognizedExchangeTableData.push("refresh");
        onClose();
      } else {
        console.error("❌ Failed to add user:", await response.text());
      }
    } catch (error) {
      console.error("❌ Network or server error:", error);
    } finally {
      setLoading(false); // ✅ stop loader
    }
  };

  if (!show) return null;

  return (
    <div className="modal" style={overlayStyle}>
      <div className="modal-content" style={modalStyle}>
        <h4 style={{ marginTop: 0, marginBottom: "20px" }}>Add New Recognized Exchange</h4>

        <button
          onClick={onClose}
          style={closeButtonStyle}
          aria-label="Close modal"
        >
          ×
        </button>

        {loading ? (
          <div style={{ textAlign: "center", padding: "20px" }}>⏳ Adding Recognized Exchange...</div>
        ) : (
          <AddRecognizedExchangesForm
            formData={formData}
            onChange={handleChange}
            onSubmit={handleSubmit}
            onCancel={onClose}
          />
        )}
      </div>
    </div>
  );
};

export default AddRecognizedExchangesFormModal;
